function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
    if (summary.classList.contains("header__icon--summary")) {
      const isOpen = !event.currentTarget.closest("details").hasAttribute("open");
        const hamburgerIcon = summary.querySelector(".categories-hamburger-icon");
        const closeIcon = summary.querySelector(".categories-close-icon");

        if (hamburgerIcon && closeIcon) {
          if (isOpen) {
            hamburgerIcon.style.display = "none";
            closeIcon.style.display = "flex";
          } else {
            hamburgerIcon.style.display = "flex";
            closeIcon.style.display = "none";
          }
        }
      
    }
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

if (typeof trapFocusHandlers === "undefined") {
  var trapFocusHandlers = {};
}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

if (typeof QuantityInput === "undefined") {
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this),
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}
if (!customElements.get("quantity-input"))
  customElements.define("quantity-input", QuantityInput);
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );

    this.querySelectorAll(
      "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)",
    ).forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary"),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  closeOthers(summaryElement) {
    const list = summaryElement.closest("ul");
    if (!list) {
      return;
    }
    const details = list.querySelectorAll("details.menu-opening");
    details.forEach((detail) => {
      if (detail.hasAttribute("open")) {
        detail.querySelector("summary")?.click();
      }
    });
  }

  onSummaryClick(event) {
    if (event.target.closest(".facet-filters-form-el")) {
      return;
    }
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    this.closeOthers(summaryElement);
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`,
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom",
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset,
      )}px`,
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset,
        )}px`,
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`,
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false),
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

window.ModalOpener =
  window.ModalOpener ||
  class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
};
if (!customElements.get("modal-opener"))
  customElements.define("modal-opener", window.ModalOpener);

window.DeferredMedia =
  window.DeferredMedia ||
  class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe"),
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
};

if (!customElements.get("deferred-media"))
  customElements.define("deferred-media", window.DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.sortImages();

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  sortImages() {
    if (!this.closest("media-gallery")) {
      return;
    }
    const slides = Array.from(this.sliderItems);

    const firstSlide = slides.shift();

    slides.sort((slideA, slideB) => {
      const aData = slideA.getAttribute("data-variant-grouping-ids")?.trim();
      const bData = slideB.getAttribute("data-variant-grouping-ids")?.trim();

      const aHasVariant = aData && aData !== "";
      const bHasVariant = bData && bData !== "";

      if (aHasVariant && !bHasVariant) {
        return -1;
      }

      if (!aHasVariant && bHasVariant) {
        return 1;
      }

      return 0;
    });

    this.slider.innerHTML = "";

    this.slider.appendChild(firstSlide);

    slides.forEach((slide) => this.slider.appendChild(slide));
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    if (!element) {
      console.error("element not found");
      return;
    }
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    this.style.pointerEvents = "none";
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
    this.style.pointerEvents = "all";
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this)),
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)",
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true },
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this),
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active",
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true,
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed,
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow,
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow,
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  initialUrl;
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);

    this.checkIfVariantIsInCart();
    this.checkIfAllVariantsAreInTheCart();
    this.initialUrl = window.location.search;

    this._forceMedaGroupingUpdateOnLoad();
  }

  _forceMedaGroupingUpdateOnLoad() {
    document.addEventListener("DOMContentLoaded", () => {
      const variantPromise = new Promise((resolve) => {
        if (this.closest("product-info") && !this.currentVariant) {
          this.onVariantChange();
        }
        resolve(); // resolve immediately after it runs
      });

      // Once the variant change has run, preload all gallery images
      variantPromise.then(() => {
        const mediaItems = document.querySelectorAll(".product__media");
        mediaItems.forEach((item) => {
          const imgs = item.querySelectorAll("img.lazy-image[data-src]");
          imgs.forEach((img) => {
            const dataSrc = img.getAttribute("data-src");
            if (dataSrc) {
              const preload = new Image();
              preload.src = dataSrc; // triggers background load
            }
          });
        });
      });
    });
  }

  onVariantChange() {
    if (window.location.href.includes("/pages/suites")) {
      // suitePageVariantChange()
      // return;
    }
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
      this.updateMedia();
    } else {
      this.updateMedia();
      this.updateMediaGrouping();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
    // if (createintervalPriceChange) {
    //   createintervalPriceChange();
    // }
    const itemsInStock =
      this.closest("product-info").querySelector(".items-in-stock");
    const productVariantSelected = this.closest(
      "product-info",
    ).querySelectorAll(
      ".product-variant:not(.hide-variant-option):not(.hide-variant-option--force)",
    );
    if (productVariantSelected) {
      itemsInStock.textContent =
        Array.from(productVariantSelected).filter(
          (el) => el.dataset.invertory > 0,
        ).length + " In-Stock";
    }

    this.checkIfAllVariantsAreInTheCart();
    if (this.initialUrl.includes("old_key=")) {
      window.location.reload();
    }

    //reset slider
    let thumbGallery = document.querySelector(
      ".thumbnail-slider.slider-mobile-gutter.quick-add-hidden",
    );

    const filterSelected =
      this.closest("product-info").querySelector(".js-cb-filter.ppf-checked")
        ?.dataset.value || "";

    thumbGallery?.classList.remove("hide-gallery-element");
    const galleryList = thumbGallery.querySelector("ul");
    const mainGalleries = this.closest("section").querySelectorAll(
      "media-gallery slider-component:not(.thumbnail-slider) ul",
    );

    setTimeout(() => {
      galleryList?.closest("slider-component")?.update();
      mainGalleries.forEach((galleryList) => {
        galleryList.closest("slider-component").update();
      });
      galleryList?.closest("slider-component")?.update();
      mainGalleries.forEach((galleryList) => {
        galleryList.closest("slider-component").update();
      });
      galleryList
        ?.querySelector("li:not(.hide-image):not(.custom-hidden) button")
        .click();
    }, 1000);
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select, fieldset"),
      (element) => {
        if (element.tagName === "SELECT") {
          return element.value;
        }
        if (element.tagName === "FIELDSET") {
          return Array.from(element.querySelectorAll("input")).find(
            (radio) => radio.checked,
          )?.value;
        }
      },
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === "SELECT" && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(
        `[data-selected-dropdown-swatch="${name}"] > .swatch`,
      );
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          swatchValue,
        );
        selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
      } else {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          "unset",
        );
        selectedDropdownSwatchValue.classList.add("swatch--unavailable");
      }
    } else if (tagName === "INPUT" && target.type === "radio") {
      const selectedSwatchValue = this.querySelector(
        `[data-selected-swatch-value="${name}"]`,
      );
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) {
      const mediaGalleries = this.closest(
        ".product-main--section",
      ).querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
      const idEl = this.closest(".product-main--section").querySelector(
        "[data-main-media]",
      );
      mediaGalleries.forEach((mediaGallery) =>
        mediaGallery.setActiveMedia(idEl.getAttribute("data-media-id"), true),
      );
      return;
    }
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = this.closest(
      ".product-main--section",
    ).querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true,
      ),
    );
    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`,
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`,
    );
    modalContent.prepend(newMediaModal);
  }

  updateMediaGrouping() {
    let featuredMedia = null;
    let featuredVariantGrouping = null;

    featuredMedia = this.closest(".product-main--section").querySelector(
      ".product__media-item.is-active",
    );
    featuredVariantGrouping = featuredMedia
      ? featuredMedia.getAttribute("data-variant-grouping")
      : null;
    const variantId = this.currentVariant.id;

    this.closest(".product-main--section")
      .querySelectorAll(".product__media-item, .thumbnail-list__item")
      .forEach((mediaItem) => {
        const mediaVariantGrouping = mediaItem.getAttribute(
          "data-variant-grouping-ids",
        );
        const isFeaturedMedia = mediaItem.getAttribute("data-featured-media");
        // OPTIMIZE THE CODE

        const condition =
          this.closest("product-info")?.querySelector(".ppf-checked")?.dataset
            .value;
        if (
          isFeaturedMedia ||
          (mediaVariantGrouping && mediaVariantGrouping.includes(variantId))
        ) {
          mediaItem.classList.remove("hide-image");
        } else {
          if (
            mediaVariantGrouping == "" &&
            (document.body.classList.contains("customer-type--consumer") ||
              document.body.classList.contains("customer-type--wholesaler"))
          ) {
            mediaItem.classList.remove("hide-image");
          } else {
            mediaItem.classList.add("hide-image");
          }

          if (
            mediaVariantGrouping == "" &&
            condition &&
            condition === "Scratch & Dent" &&
            this.closest("prodduct-info")?.querySelectorAll(
              ".product-variant:has(input:checked)",
            ).length > 0
          ) {
            mediaItem.classList.add("hide-image");
          }
        }
      });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    if (window.location.href.includes("pages/suites")) {
      const urlParams = new URLSearchParams(window.location.search);
      let url = `/pages/suites?product_1=${urlParams.get(
        "product_1",
      )}&product_2=${urlParams.get("product_2")}`;

      let currentVariants = urlParams.get("variants");

      if (!currentVariants) {
        url += `&variants=${this.currentVariant.id}`;
      } else {
        let currentVariantsArr = currentVariants
          .split(",")
          .map((variant) => parseInt(variant));
        let variantsSelected = variantsArrSuite.find((arr) =>
          arr.includes(this.currentVariant.id),
        );

        let result = currentVariantsArr.map((variantInUrl) => {
          return variantsSelected.includes(variantInUrl)
            ? this.currentVariant.id
            : variantInUrl;
        });

        !result.includes(this.currentVariant.id) &&
          result.push(this.currentVariant.id);
        url += `&variants=${result.join(",")}`;
      }

      window.history.replaceState({}, "", url);

      return;
    }
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`,
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateVariantInput() {
    const productForms = this.closest(
      ".product-main--section",
    ).querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1,
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected,
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute("value");
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === "INPUT") {
        element.classList.toggle("disabled", !availableElement);
      } else if (element.tagName === "OPTION") {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace(
              "[value]",
              value,
            );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = this.closest(
      ".product-main--section",
    ).querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    let section = this.closest("section");
    if (window.location.href.includes("/pages/suites")) {
      section = this.closest("suite-product");
    }
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    let fecthURL = `${
      this.dataset.url
    }?variant=${requestedVariantId}&section_id=${
      this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section
    }`;
    if (window.location.href.includes("/pages/suites"))
      fecthURL = `${this.dataset.url}?variant=${requestedVariantId}`;
    fetch(fecthURL)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");

        if (window.location.href.includes("/pages/suites")) {
          this.dataset.originalSection = html.querySelector(
            ".product-main--section",
          ).dataset.section;
        }
        const destination = this.closest(
          ".product-main--section",
        ).querySelector(`#price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );

        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const skuDestination = this.closest(
          ".product-main--section",
        ).querySelector(`#Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const inventoryDestination = this.closest(
          ".product-main--section",
        ).querySelector(`#Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );

        const pricePerItemDestination = this.closest(
          ".product-main--section",
        ).querySelector(`#Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );

        const volumePricingDestination = this.closest(
          ".product-main--section",
        ).querySelector(`#Volume-${this.dataset.section}`);
        const qtyRules = this.closest(".product-main--section").querySelector(
          `#Quantity-Rules-${this.dataset.section}`,
        );
        const volumeNote = this.closest(".product-main--section").querySelector(
          `#Volume-Note-${this.dataset.section}`,
        );

        if (volumeNote) volumeNote.classList.remove("hidden");
        if (volumePricingDestination)
          volumePricingDestination.classList.remove("hidden");
        if (qtyRules) qtyRules.classList.remove("hidden");

        if (source && destination) {
          destination.innerHTML = source.innerHTML;
          this.updateStickyCTA();
        }
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "hidden",
            skuSource.classList.contains("hidden"),
          );
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle(
            "hidden",
            pricePerItemSource.classList.contains("hidden"),
          );
        }

        const financeBoxSource = html.querySelector(".mpfs__finance-box");
        const financeBoxDestination = this.closest(
          ".product-main--section",
        ).querySelector(".mpfs__finance-box");

        if (financeBoxSource && financeBoxDestination) {
          financeBoxDestination.innerHTML = financeBoxSource.innerHTML;
        }

        const price = this.closest(".product-main--section").querySelector(
          `#price-${this.dataset.section}`,
        );

        if (price) price.classList.remove("hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "hidden",
            inventorySource.innerText === "",
          );

        let addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`,
        );

        if (window.location.href.includes("/pages/suites")) {
          addButtonUpdated = html.getElementById(
            `ProductSubmitButton-${this.dataset.originalSection}`,
          );
        }

        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut,
        );

        if (addButtonUpdated) {
          const currentButton = this.closest(
            ".product-main--section",
          ).querySelector(`#ProductSubmitButton-${this.dataset.section}`);
          if (currentButton) {
            const updatedPriceSpan = addButtonUpdated.querySelector(
              "[data-variant-price]",
            );
            const currentPriceSpan = currentButton.querySelector(
              "[data-variant-price]",
            );

            if (updatedPriceSpan && currentPriceSpan) {
              currentPriceSpan.textContent = updatedPriceSpan.textContent;
            }

            const updatedBundleVariants = addButtonUpdated.getAttribute(
              "data-bundle-variants",
            );
            if (updatedBundleVariants) {
              currentButton.setAttribute(
                "data-bundle-variants",
                updatedBundleVariants,
              );
            }
          }
        }

        const financeSnippetSource = html.querySelector(
          `#finance-box-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const financeSnippetDestination = this.closest(
          ".product-main--section",
        ).querySelector(`#finance-box-${this.dataset.section}`);

        if (financeSnippetSource && financeSnippetDestination) {
          financeSnippetDestination.innerHTML = financeSnippetSource.innerHTML;
        }

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] div span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = "Sold out";
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] div span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`,
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`,
    );
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`,
    );
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`,
    );
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`,
    );

    if (!addButton) return;
    if (addButtonText)
      addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("hidden");
    if (inventory) inventory.classList.add("hidden");
    if (sku) sku.classList.add("hidden");
    if (pricePerItem) pricePerItem.classList.add("hidden");
    if (volumeNote) volumeNote.classList.add("hidden");
    if (volumeTable) volumeTable.classList.add("hidden");
    if (qtyRules) qtyRules.classList.add("hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  checkIfAllVariantsAreInTheCart() {
    if (
      !window.location.href.includes("variant=") ||
      window.location.href.includes("old_key=")
    ) {
      return;
    }
    const atc = this.closest("product-info").querySelector(
      ".product-form__submit",
    );
    atc.classList.remove("disabled");
    atc.querySelector("div span").textContent = "Add to cart";
    const selectedVar = this.querySelector(
      ".product-variant:has(input:checked)",
    );
    fetch(window.Shopify.routes.root + "cart.js")
      .then((response) => response.json())
      .then((data) => {
        const variants = data.items;
        const variant = variants.find(
          (variant) =>
            variant.variant_id == parseInt(selectedVar.dataset.variantId),
        );

        if (variant) {
          const qty = variant.quantity;
          const invertory = selectedVar.dataset.invertory;

          if (invertory) {
            if (parseInt(invertory) - qty <= 0) {
              setTimeout(() => {
                atc.classList.add("disabled");
                atc.querySelector("div span").textContent = "Added to Cart";
                atc.classList.add("added-to-the-cart");
                this.checkIfVariantIsInCart();
              }, 700);
            }
          }
        }
      });
  }

  checkIfVariantIsInCart() {
    fetch(window.Shopify.routes.root + "cart.js")
      .then((response) => response.json())
      .then((data) => {
        const variantsInCart = data.items.map((item) => item.variant_id);

        const productOptions = this.querySelectorAll(
          ".product-options-btns__container .product-variant",
        );

        productOptions.forEach((option) => {
          if (variantsInCart.includes(parseInt(option.dataset.variantId))) {
            if (!option.querySelector(".variant-is-in-cart")) {
              const div = document.createElement("div");
              div.classList.add("variant-is-in-cart");
              div.innerHTML = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.2836 9.01807L15.9678 3.41877C16.0035 3.29973 16.0096 3.17445 15.9857 3.05277C15.9618 2.9311 15.9085 2.81636 15.8299 2.71758C15.7514 2.6188 15.6498 2.53868 15.5332 2.48352C15.4165 2.42836 15.288 2.39967 15.1577 2.3997H4.01679L3.51574 0.595925C3.46832 0.42513 3.36272 0.274047 3.21542 0.166246C3.06811 0.0584447 2.88739 -1.04106e-05 2.70144 1.39069e-09H0.842093C0.618756 1.39069e-09 0.404566 0.0842749 0.246643 0.234285C0.0887203 0.384295 0 0.587753 0 0.7999C0 1.01205 0.0887203 1.2155 0.246643 1.36551C0.404566 1.51552 0.618756 1.5998 0.842093 1.5998H2.05302L2.55828 3.40357V3.41157V3.41877L4.24247 9.01807L4.87067 11.4066C4.45479 11.5817 4.09642 11.8603 3.8334 12.2129C3.57038 12.5655 3.41247 12.979 3.37635 13.4098C3.34023 13.8405 3.42724 14.2726 3.62818 14.6603C3.82913 15.048 4.13655 15.3769 4.518 15.6124C4.89945 15.8479 5.34076 15.9812 5.79534 15.9981C6.24991 16.0151 6.70088 15.9152 7.10063 15.7089C7.50038 15.5026 7.83406 15.1976 8.06645 14.8261C8.29884 14.4546 8.42131 14.0304 8.42093 13.5983C8.41814 13.3252 8.36572 13.0546 8.26599 12.7984H10.2601C10.1603 13.0546 10.1079 13.3252 10.1051 13.5983C10.1051 14.0729 10.2533 14.5369 10.5309 14.9315C10.8085 15.3261 11.203 15.6337 11.6646 15.8153C12.1263 15.997 12.6342 16.0445 13.1243 15.9519C13.6143 15.8593 14.0644 15.6307 14.4177 15.2951C14.7711 14.9595 15.0117 14.532 15.1091 14.0665C15.2066 13.601 15.1566 13.1185 14.9654 12.68C14.7742 12.2415 14.4504 11.8667 14.0349 11.603C13.6195 11.3393 13.1311 11.1986 12.6314 11.1986H6.55149L6.13044 9.5988H13.4735C13.6566 9.59884 13.8348 9.54218 13.981 9.43738C14.1272 9.33259 14.2334 9.18538 14.2836 9.01807ZM12.6314 12.7984C12.7979 12.7984 12.9608 12.8453 13.0992 12.9332C13.2377 13.0211 13.3457 13.146 13.4094 13.2922C13.4731 13.4384 13.4898 13.5992 13.4573 13.7543C13.4248 13.9095 13.3446 14.052 13.2268 14.1639C13.1091 14.2758 12.959 14.352 12.7957 14.3828C12.6323 14.4137 12.463 14.3979 12.3091 14.3373C12.1553 14.2768 12.0238 14.1742 11.9312 14.0427C11.8387 13.9112 11.7893 13.7565 11.7893 13.5983C11.7893 13.3861 11.878 13.1827 12.0359 13.0327C12.1939 12.8827 12.4081 12.7984 12.6314 12.7984ZM6.73675 13.5983C6.73675 13.7565 6.68736 13.9112 6.59483 14.0427C6.5023 14.1742 6.37078 14.2768 6.21691 14.3373C6.06304 14.3979 5.89372 14.4137 5.73037 14.3828C5.56702 14.352 5.41697 14.2758 5.2992 14.1639C5.18143 14.052 5.10123 13.9095 5.06874 13.7543C5.03625 13.5992 5.05292 13.4384 5.11666 13.2922C5.1804 13.146 5.28833 13.0211 5.42681 12.9332C5.56529 12.8453 5.7281 12.7984 5.89465 12.7984C6.11799 12.7984 6.33218 12.8827 6.4901 13.0327C6.64803 13.1827 6.73675 13.3861 6.73675 13.5983ZM10.9472 6.3992H10.1051V7.1991C10.1051 7.41124 10.0164 7.6147 9.85848 7.76471C9.70055 7.91472 9.48636 7.999 9.26303 7.999C9.03969 7.999 8.8255 7.91472 8.66758 7.76471C8.50965 7.6147 8.42093 7.41124 8.42093 7.1991V6.3992H7.57884C7.3555 6.3992 7.14131 6.31492 6.98339 6.16491C6.82547 6.0149 6.73675 5.81145 6.73675 5.5993C6.73675 5.38715 6.82547 5.18369 6.98339 5.03368C7.14131 4.88367 7.3555 4.7994 7.57884 4.7994H8.42093V3.9995C8.42093 3.78735 8.50965 3.58389 8.66758 3.43388C8.8255 3.28387 9.03969 3.1996 9.26303 3.1996C9.48636 3.1996 9.70055 3.28387 9.85848 3.43388C10.0164 3.58389 10.1051 3.78735 10.1051 3.9995V4.7994H10.9472C11.1705 4.7994 11.3847 4.88367 11.5427 5.03368C11.7006 5.18369 11.7893 5.38715 11.7893 5.5993C11.7893 5.81145 11.7006 6.0149 11.5427 6.16491C11.3847 6.31492 11.1705 6.3992 10.9472 6.3992Z" fill="white"/>
              </svg>
              `;
              option.appendChild(div);
            }
          }
        });
        if (document.body.classList.contains("customer-type--consumer")) {
          const filterNew = document.querySelector(
            `.js-cb-filter[data-value="New"]`,
          );
          const filterrefurbrish = document.querySelector(
            `.js-cb-filter[data-value="Like-New / Refurb."]`,
          );
          if (filterNew) {
            if (filterNew.classList.contains("ppf-checked")) {
              const newVariants = this.querySelectorAll(
                `.product-options-btns__container .product-variant[data-condition="New"]`,
              );
              const el = Array.from(newVariants).find(
                (variant) =>
                  parseInt(variant.dataset.invertory) > 0 &&
                  !variant.querySelector(".variant-is-in-cart"),
              );

              if (el) {
                el.querySelector("input").click();
                setTimeout(() => {
                  this.checkIfAllVariantsAreInTheCart();
                }, 100);
              }
            }
          }
          if (filterrefurbrish) {
            if (filterrefurbrish.classList.contains("ppf-checked")) {
              const newVariants = this.querySelectorAll(
                `.product-options-btns__container .product-variant[data-condition="Like-New / Refurb."]`,
              );
              const el = Array.from(newVariants).find(
                (variant) =>
                  parseInt(variant.dataset.invertory) > 0 &&
                  !variant.querySelector(".variant-is-in-cart"),
              );

              if (el) {
                el.querySelector("input").click();
                setTimeout(() => {
                  this.checkIfAllVariantsAreInTheCart();
                }, 100);
              }
            }
          }
        }
      });
    window.dispatchEvent(new CustomEvent("check::variant-in-cart"));
  }

  updateStickyCTA() {
    const stickyCTAContainer = document.getElementById("sticky-cta-container");

    if (!stickyCTAContainer || !this.currentVariant) {
      return;
    }

    stickyCTAContainer.setAttribute("data-variant-id", this.currentVariant.id);
    stickyCTAContainer.setAttribute(
      "data-is-available",
      this.currentVariant.available,
    );

    const event = new CustomEvent("variant-change", {
      detail: {
        variantId: this.currentVariant.id,
        available: this.currentVariant.available,
      },
    });
    document.dispatchEvent(event);
  }
}

customElements.define("variant-selects", VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }

          let counter = 0;
          const interval = setInterval(() => {
            counter++;
            if (counter > 10) {
              clearInterval(interval);
            }

            this.querySelectorAll(
              ".price-remove:not(:has(.new-price))",
            ).forEach((el) => {
              if (el.querySelector(".samitaWS-customized-price")) {
                const currentPrice = getNumberFromstring(
                  el.querySelector(".samitaWS-customized-price").textContent,
                );
                const oldPrice = getNumberFromstring(
                  el.closest(".product-card-wrapper").dataset.ogPrice,
                );
                const discount = (100 * (oldPrice - currentPrice)) / oldPrice;
                if (parseInt(discount) > 2)
                  el.innerHTML = `<span class="old-price" style="text-decoration:line-through;display: none">$${oldPrice}</span>
              <span class="new-price">$${currentPrice}</span>
              <span class="percent-saved"
                >
                ${parseInt(discount)}% LESS THAN RETAIL
              </span>`;
              }
            });
          }, 500);
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

const checkCustomerType = async () => {
  let customerType = "Consumer";

  if (window.customerTags.includes("Wholesaler")) {
    customerType = "Wholesaler";
  }
  if (window.customerTags.includes("Truckload-buyer")) {
    customerType = "Truckload-buyer";
  }
  const savedCustomerType = localStorage.getItem("saved-customer-type");
  if (!savedCustomerType) {
    localStorage.setItem("saved-customer-type", customerType);
    return;
  }
  if (customerType !== savedCustomerType) {
    localStorage.setItem("saved-customer-type", customerType);

    fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
};

document.addEventListener("DOMContentLoaded", () => {
  window.dispatchEvent(new CustomEvent("check::variant-in-cart"));

  //check customer type
  checkCustomerType();
});

window.addEventListener("load", () => {
  setTimeout(() => {
    document.documentElement.style.scrollPaddingTop = "0px";
  }, 1);
});

class CategoriesDrawer extends HTMLElement {
  constructor() {
    super();

    this._initTopPosition();

    this._initMenuCollapse();
    this._openingTriggers();
    this._closingTriggers();
  }
  _initTopPosition() {
    // Calculate all heights directly
    const stickyHeader = document.querySelector("sticky-header");
    const stickyHeaderHeight = stickyHeader ? stickyHeader.offsetHeight : 80;

    const announcementBar = document.querySelector(".announcement-bar-section");
    const announcementBarHeight = announcementBar
      ? announcementBar.offsetHeight
      : 0;

    const headerheight = document.querySelector(".product-categories-nav");
    if (!headerheight) {
      console.error("Error header container not found");
      return;
    }

    const isScrolled = announcementBarHeight - window.scrollY;
    const visibleAnnouncementHeight = isScrolled > 0 ? isScrolled : 0;
    const totalStickyHeight =
      isScrolled < announcementBarHeight
        ? stickyHeaderHeight
        : stickyHeaderHeight + announcementBarHeight;

    const topPosition =
      totalStickyHeight + headerheight.offsetHeight;
    const containerHeight =
      window.innerHeight -
      totalStickyHeight -
      visibleAnnouncementHeight -
      headerheight.offsetHeight;

    this.querySelector(".cd__container").style.top = `${topPosition}px`;
    this.querySelector(".cd__container").style.height = `${containerHeight}px`;
  }
  _setupScrollListener() {
    if (this.scrollListener) return;

    let ticking = false;
    this.scrollListener = () => {
      if (this.classList.contains("open") && !ticking) {
        requestAnimationFrame(() => {
          this._initTopPosition();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", this.scrollListener, { passive: true });
    window.addEventListener("resize", this.scrollListener);

    // Also listen for header state changes
    const header = document.querySelector(".section-header");
    if (header) {
      this.headerObserver = new MutationObserver(() => {
        if (this.classList.contains("open")) {
          this._initTopPosition();
        }
      });
      this.headerObserver.observe(header, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }
  }
  _removeScrollListener() {
    if (this.scrollListener) {
      window.removeEventListener("scroll", this.scrollListener);
      window.removeEventListener("resize", this.scrollListener);
      this.scrollListener = null;
    }
    if (this.headerObserver) {
      this.headerObserver.disconnect();
      this.headerObserver = null;
    }
  }
  _initMenuCollapse() {
    this.querySelectorAll(".cd__category-title").forEach((title) => {
      title.addEventListener("click", () => {
        title.classList.toggle("opened");
      });
    });
  }
  _open() {
    this._initTopPosition();
    this._setupScrollListener();
    this.classList.add("opening");
    this._toggleIcons(true);
    setTimeout(() => {
      this.classList.add("open");
      this.classList.remove("opening");
      document.querySelector("html").classList.add("categories-drawer-opened");
    }, 60);
  }
  _close() {
    this.classList.add("closing");
    this._toggleIcons(false);
    this._removeScrollListener();
    setTimeout(() => {
      this.classList.remove("open");
      this.classList.remove("closing");
      document
        .querySelector("html")
        .classList.remove("categories-drawer-opened");
    }, 600);
  }
  open() {
    this._open();
  }
  _openingTriggers() {
    document.querySelectorAll(".header-categories-button").forEach((btn) => {
      btn.addEventListener("click", () => {
        this._open();
      });
    });
  }
  _closingTriggers() {
    this.querySelector(".overlay").addEventListener("click", () => {
      this._close();
    });
    document.querySelectorAll(".header-categories-button").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        if (this.classList.contains("open")) {
          e.preventDefault();
          this._close();
        }
      });
    });
  }

  _toggleIcons(isOpen) {
    document.querySelectorAll(".header-categories-button").forEach((btn) => {
      const hamburgerIcon = btn.querySelector(".categories-hamburger-icon");
      const closeIcon = btn.querySelector(".categories-close-icon");

      if (hamburgerIcon && closeIcon) {
        if (isOpen) {
          hamburgerIcon.style.display = "none";
          closeIcon.style.display = "block";
        } else {
          hamburgerIcon.style.display = "block";
          closeIcon.style.display = "none";
        }
      }
    });
  }
}

customElements.define("categories-drawer", CategoriesDrawer);

class HfdDropdown extends HTMLElement {
  constructor() {
    super();

    this._initTopPosition();

    this._openingTriggers();
    this._closingTriggers();
  }
  _initTopPosition() {
    // Calculate all heights directly
    const stickyHeader = document.querySelector("sticky-header");
    const stickyHeaderHeight = stickyHeader ? stickyHeader.offsetHeight : 80;

    const announcementBar = document.querySelector(".announcement-bar-section");
    const announcementBarHeight = announcementBar
      ? announcementBar.offsetHeight
      : 0;

    const headerheight = document.querySelector(".product-categories-nav");
    if (!headerheight) {
      console.error("Error header container not found");
      return;
    }

    const isScrolled = announcementBarHeight - window.scrollY;
    const visibleAnnouncementHeight = isScrolled > 0 ? isScrolled : 0;
    const totalStickyHeight =
      isScrolled < announcementBarHeight
        ? stickyHeaderHeight + headerheight.offsetHeight + announcementBarHeight
        : stickyHeaderHeight + headerheight.offsetHeight;

    const topPosition =
      totalStickyHeight;
    const containerHeight =
      window.innerHeight -
      totalStickyHeight -
      visibleAnnouncementHeight -
      headerheight.offsetHeight;

    this.querySelector(".hfd__container").style.top = `${topPosition}px`;
    this.querySelector(".hfd__container").style.height = `${containerHeight}px`;
  }
  _setupScrollListener() {
    if (this.scrollListener) return;

    let ticking = false;
    this.scrollListener = () => {
      if (this.classList.contains("open") && !ticking) {
        requestAnimationFrame(() => {
          this._initTopPosition();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", this.scrollListener, { passive: true });
    window.addEventListener("resize", this.scrollListener);

    // Also listen for header state changes
    const header = document.querySelector(".section-header");
    if (header) {
      this.headerObserver = new MutationObserver(() => {
        if (this.classList.contains("open")) {
          this._initTopPosition();
        }
      });
      this.headerObserver.observe(header, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }
  }
  _removeScrollListener() {
    if (this.scrollListener) {
      window.removeEventListener("scroll", this.scrollListener);
      window.removeEventListener("resize", this.scrollListener);
      this.scrollListener = null;
    }
    if (this.headerObserver) {
      this.headerObserver.disconnect();
      this.headerObserver = null;
    }
  }

  _open() {
    this._initTopPosition();
    this._setupScrollListener();
    this.classList.add("opening");
    setTimeout(() => {
      this.classList.add("open");
      this.classList.remove("opening");
      document.querySelector("html").classList.add("featured-drawer-opened");
    }, 60);
  }
  _close() {
    this.classList.add("closing");
    this._removeScrollListener();
    setTimeout(() => {
      this.classList.remove("open");
      this.classList.remove("closing");
      document.querySelector("html").classList.remove("featured-drawer-opened");
    }, 600);
  }
  open() {
    this._open();
  }
  _openingTriggers() {
    document.querySelectorAll(".hfd__btn").forEach((btn) => {
      btn.addEventListener("click", () => {
        this._open();
      });
    });
  }
  _closingTriggers() {
    this.querySelector(".overlay").addEventListener("click", () => {
      this._close();
    });
  }
}

customElements.define("hfd-dropdown", HfdDropdown);

class MainNavDropdown extends HTMLElement {
  constructor() {
    super();

    this._initTopPosition();

    this._openingTriggers();
    this._closingTriggers();
    this._initParentLinks();
    this._initCloseChildrenBox();
    this._initMenuCollapse();
  }
  _initTopPosition() {
    // Calculate all heights directly
    const stickyHeader = document.querySelector("sticky-header");
    const stickyHeaderHeight = stickyHeader ? stickyHeader.offsetHeight : 80;

    const announcementBar = document.querySelector(".announcement-bar-section");
    const announcementBarHeight = announcementBar
      ? announcementBar.offsetHeight
      : 0;

    const headerheight = document.querySelector(".product-categories-nav");
    if (!headerheight) {
      console.error("Error header container not found");
      return;
    }

    const isScrolled = announcementBarHeight - window.scrollY;
    const visibleAnnouncementHeight = isScrolled > 0 ? isScrolled : 0;
    const totalStickyHeight =
      isScrolled < announcementBarHeight
        ? stickyHeaderHeight + headerheight.offsetHeight
        : stickyHeaderHeight + headerheight.offsetHeight + announcementBarHeight;

    const topPosition =
      totalStickyHeight;
    const containerHeight =
      window.innerHeight -
      totalStickyHeight -
      visibleAnnouncementHeight -
      headerheight.offsetHeight;

    this.querySelector(".mnd__container").style.top = `${topPosition}px`;
    this.querySelector(".mnd__container").style.height = `${containerHeight}px`;
  }
  _setupScrollListener() {
    if (this.scrollListener) return;

    let ticking = false;
    this.scrollListener = () => {
      if (this.classList.contains("open") && !ticking) {
        requestAnimationFrame(() => {
          this._initTopPosition();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", this.scrollListener, { passive: true });
    window.addEventListener("resize", this.scrollListener);

    // Also listen for header state changes
    const header = document.querySelector(".section-header");
    if (header) {
      this.headerObserver = new MutationObserver(() => {
        if (this.classList.contains("open")) {
          this._initTopPosition();
        }
      });
      this.headerObserver.observe(header, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }
  }
  _removeScrollListener() {
    if (this.scrollListener) {
      window.removeEventListener("scroll", this.scrollListener);
      window.removeEventListener("resize", this.scrollListener);
      this.scrollListener = null;
    }
    if (this.headerObserver) {
      this.headerObserver.disconnect();
      this.headerObserver = null;
    }
  }

  _initMenuCollapse() {
    this.querySelectorAll(".mnd__category-title").forEach((title) => {
      title.addEventListener("click", () => {
        title.classList.toggle("opened");
      });
    });
  }
  _initParentLinks() {
    const parentLinks = this.querySelectorAll(".mnd__row-has-children");
    parentLinks.forEach((link) => {
      link.querySelector(".mnd__title").addEventListener("click", (e) => {
        link.classList.add("opened");
      });
    });
  }

  _initCloseChildrenBox() {
    const childLinksClosers = this.querySelectorAll(".close-children-block");
    childLinksClosers.forEach((closeBtn) => {
      closeBtn.addEventListener("click", () => {
        closeBtn.closest(".mnd__row-has-children").classList.remove("opened");
      });
    });
  }

  _open() {
    this._initTopPosition();
    this._setupScrollListener();
    this.classList.add("opening");
    setTimeout(() => {
      this.classList.add("open");
      this.classList.remove("opening");
      document.querySelector("html").classList.add("main-nav-opened");
    }, 60);
  }
  _close() {
    this.classList.add("closing");
    this._removeScrollListener();
    setTimeout(() => {
      this.classList.remove("open");
      this.classList.remove("closing");
      document.querySelector("html").classList.remove("main-nav-opened");
    }, 600);
  }
  open() {
    this._open();
  }
  _openingTriggers() {
    document.querySelectorAll(".mnd__btn ").forEach((btn) => {
      btn.addEventListener("click", () => {
        this._open();
      });
    });
  }
  _closingTriggers() {
    this.querySelector(".overlay").addEventListener("click", () => {
      this._close();
    });
    this.querySelector(".overlay").addEventListener("mouseover", () => {
      if (this.classList.contains("open")) this._close();
    });
  }
}

customElements.define("main-nav-dropdown", MainNavDropdown);

class PrefixPrices extends HTMLElement {
  constructor() {
    super();
    this.priceInputElGte = this.closest("facet-filters-form").querySelector(
      `price-range input[name="filter.v.price.gte"]`,
    );
    this.priceInputElLte = this.closest("facet-filters-form").querySelector(
      `price-range input[name="filter.v.price.lte"]`,
    );
    this._init();
  }

  _init() {
    const pricesItems = this.querySelectorAll(".js-prefix-prices__item");
    pricesItems.forEach((item) => {
      item.addEventListener("click", () => {
        this._handlePriceClick(item);
      });
    });

    const resetPricesBtn = this.querySelector(".reset-pricing-filter");
    if (resetPricesBtn) {
      resetPricesBtn.addEventListener("click", () => {
        this._resetPrices();
      });
    }
  }
  _resetPrices() {
    this.querySelectorAll(".js-prefix-prices__item").forEach((item) => {
      item.dataset.clicked = "false";
    });
    this.priceInputElGte.value = "";
    this.priceInputElGte.dispatchEvent(new Event("input", { bubbles: true }));
    this.priceInputElLte.value = "";
    this.priceInputElLte.dispatchEvent(new Event("input", { bubbles: true }));
  }
  _handlePriceClick(item) {
    const { gte, lte, gteExists, lteExists } = this._getPricesFromUrl();
    const itemGte = Number(
      item.querySelector(".js-prefix-prices__item--gte").getAttribute("value"),
    );
    const itemLte = Number(
      item.querySelector(".js-prefix-prices__item--lte").getAttribute("value"),
    );

    const isClicked = item.dataset.clicked;
    if (isClicked === "true") {
      item.dataset.clicked = "false";
      /*
        If item was clicked then we should remove filters,
        with the following logic: remove the Gte if itemGte is lower than gte,
        remove the Lte if itemLte is higher than lte
      */

      const lowestGteSelected = this._findLowestGte();

      if (lowestGteSelected && itemGte < lowestGteSelected) {
        this.priceInputElGte.value = lowestGteSelected;
        this.priceInputElGte.dispatchEvent(
          new Event("input", { bubbles: true }),
        );
      } else if (!lowestGteSelected) {
        this.priceInputElGte.value = "";
        this.priceInputElGte.dispatchEvent(
          new Event("input", { bubbles: true }),
        );
      }
      const highestLteSelected = this._findHighestLte();
      if (highestLteSelected && itemLte > highestLteSelected) {
        this.priceInputElLte.value = highestLteSelected;
        this.priceInputElLte.dispatchEvent(
          new Event("input", { bubbles: true }),
        );
      } else if (!highestLteSelected) {
        this.priceInputElLte.value = "";
        this.priceInputElLte.dispatchEvent(
          new Event("input", { bubbles: true }),
        );
      }
    } else {
      if (gteExists) {
        const lowestGteSelected = this._findLowestGte();
        if (lowestGteSelected && itemGte < lowestGteSelected) {
          this.priceInputElGte.value = itemGte;
          this.priceInputElGte.dispatchEvent(
            new Event("input", { bubbles: true }),
          );
        }
      } else {
        this.priceInputElGte.value = itemGte;
        this.priceInputElGte.dispatchEvent(
          new Event("input", { bubbles: true }),
        );
      }
      if (lteExists) {
        const highestLteSelected = this._findHighestLte();
        if (highestLteSelected && itemLte > highestLteSelected) {
          this.priceInputElLte.value = itemLte;
          this.priceInputElLte.dispatchEvent(
            new Event("input", { bubbles: true }),
          );
        }
      } else {
        this.priceInputElLte.value = itemLte;
        this.priceInputElLte.dispatchEvent(
          new Event("input", { bubbles: true }),
        );
      }

      item.dataset.clicked = "true";
    }
  }
  _getPricesFromUrl() {
    //get url params
    const urlParams = new URLSearchParams(window.location.search);
    return {
      gteExists: urlParams.has("filter.v.price.gte"),
      lteExists: urlParams.has("filter.v.price.lte"),
      gte: Math.max(Number(urlParams.get("filter.v.price.gte")), 0),
      lte: Math.max(Number(urlParams.get("filter.v.price.lte")), 0),
    };
  }
  _findLowestGte() {
    const selectedElements = Array.from(
      this.querySelectorAll(`.js-prefix-prices__item[data-clicked="true"]`),
    );
    const sortedElements = selectedElements.sort((a, b) => {
      const aGte = Number(
        a.querySelector(".js-prefix-prices__item--gte").value,
      );
      const bGte = Number(
        b.querySelector(".js-prefix-prices__item--gte").value,
      );
      return aGte - bGte;
    });
    return sortedElements.length > 0 ? sortedElements[0] : null;
  }
  _findHighestLte() {
    const selectedElements = Array.from(
      this.querySelectorAll(`.js-prefix-prices__item[data-clicked="true"]`),
    );
    const sortedElements = selectedElements.sort((a, b) => {
      const aLte = Number(
        a.querySelector(".js-prefix-prices__item--lte").value,
      );
      const bLte = Number(
        b.querySelector(".js-prefix-prices__item--lte").value,
      );
      return bLte - aLte;
    });
    return sortedElements.length > 0 ? sortedElements[0] : null;
  }
}

customElements.define("prefix-prices", PrefixPrices);

class CategorySeacrh extends HTMLElement {
  constructor() {
    super();
    this.searchInput = this.querySelector(".category-search__input");
    this._init();
  }

  _init() {
    this.searchInput.addEventListener("input", () => {
      this._handleSearch();
    });
  }

  _handleSearch() {
    const searchValue = this.searchInput.value.toLowerCase();
    const categories = this.closest("details").querySelectorAll(
      `input[name="filter.p.product_type"]`,
    );
    categories.forEach((category) => {
      const categoryName = category.value.toLowerCase();
      if (categoryName.includes(searchValue)) {
        category.closest(".facets__item").classList.remove("hidden");
      } else {
        category.closest(".facets__item").classList.add("hidden");
      }
    });
  }
}

customElements.define("category-search", CategorySeacrh);

function closeTooltip() {
  document
    .querySelectorAll(".product__media-tooltip-open")
    .forEach(function (el) {
      el.style.setProperty("display", "none", "important");
    });
  document
    .querySelectorAll(".product__media-tooltip-expand")
    .forEach(function (el) {
      el.style.setProperty("display", "none", "important");
    });
  document
    .querySelectorAll(".product__media-tooltip-closed")
    .forEach(function (el) {
      el.style.setProperty("display", "flex", "important");
    });
}

function openTooltip() {
  document
    .querySelectorAll(".product__media-tooltip-open")
    .forEach(function (el) {
      el.style.setProperty("display", "flex", "important");
    });
  document
    .querySelectorAll(".product__media-tooltip-closed")
    .forEach(function (el) {
      el.style.setProperty("display", "none", "important");
    });
}

function expandTooltip() {
  document
    .querySelectorAll(".product__media-tooltip-expand")
    .forEach(function (el) {
      el.style.setProperty("display", "flex", "important");
    });
  document
    .querySelectorAll(".product__media-tooltip-open")
    .forEach(function (el) {
      el.style.setProperty("display", "none", "important");
    });
  // document.getElementById('condition').scrollIntoView({ behavior: 'smooth' });
}

function shrinkTooltip() {
  document
    .querySelectorAll(".product__media-tooltip-expand")
    .forEach(function (el) {
      el.style.setProperty("display", "none", "important");
    });
  document
    .querySelectorAll(".product__media-tooltip-open")
    .forEach(function (el) {
      el.style.setProperty("display", "flex", "important");
    });
  // document.getElementById('condition').scrollIntoView({ behavior: 'smooth' });
}

function tooltipToggle() {
  const expandTooltipEl = document.querySelector(
    ".product__media-tooltip-expand",
  );
  const openTooltipEl = document.querySelector(".product__media-tooltip-open");

  if (!expandTooltipEl || !openTooltipEl) return;

  // Check if the expanded view is currently visible
  // Using getComputedStyle is more reliable for checking the actual display state
  const isExpanded =
    window.getComputedStyle(expandTooltipEl).display !== "none";

  if (isExpanded) {
    shrinkTooltip();
  } else {
    expandTooltip();
  }
}

//TODO: DELETE IN JULY IF NOT USED
// class ShopPageContent extends HTMLElement {
//   constructor() {
//     super();
//     this.parentElement.classList.remove("show");
//     //this._init();
//   }

//   connectedCallback() {
//     this._init();
//   }

//   _init() {
//     const sections = document.querySelectorAll(
//       ".featured-products-section-class, .further-reduced-section-class, .new-arrivals-section-class"
//     );

//     if (sections.length === 0) {
//       return;
//     }
//     this.innerHTML = "";

//     sections.forEach((section) => {
//       this.innerHTML += section.outerHTML;
//       //this.appendChild(section);
//     });
//     setTimeout(() => {
//       window.dispatchEvent(new Event("resize", { bubbles: true }));
//     }, 80);

//     this.parentElement.classList.add("show");
//   }
// }
// customElements.define("shop-page-content", ShopPageContent);
